module.exports = __webpack_public_path__ + "static/media/insulin.72de14fe.svg";